module.exports = __webpack_public_path__ + "static/media/blinking-leds.dd69985a.gif";